import { ManageEducationContentComponent } from './manage-education-content/manage-education-content.component';

export const ADMIN_COMPONENTS = [
  ManageEducationContentComponent
];

export * from './manage-education-content/manage-education-content.component';